module.exports = __webpack_public_path__ + "img/pr-3.2c013586.png";